module.exports = __webpack_public_path__ + "static/media/hexagon.47b93624.svg";